module.exports = __webpack_public_path__ + "media/images/john-tree-f607a27d0c7d10db346d89029fc48668.png";